import React, { useEffect, useState } from "react";
import "./Users.css";
import { NavLink, useSearchParams } from "react-router-dom";
import HeaderUser from "../../components/Header/HeaderUser";
import { MdSearch, MdFilterList, MdMoreHoriz } from "react-icons/md";
import Pagination from "../../components/MiniComponents/Pagination";
import toast, { Toaster } from "react-hot-toast";

import {
  getAllUsers,
  getActiveUsers,
  getInactiveUsers,
  blockUserApi,
  unblockUserApi,
} from "../../api/UserApi";
import useDebounce from "../../hooks/useDebounce";

const columns = [
  "S.No",
  "Username",
  "Account Type",
  "Login Detail",
  "Phone Number",
  "Coin Balance",
  "Created At",
  "Status",
  "Actions",
];

const Users = () => {
  const [users, setUsers] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  // const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState(null);
  // const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const search = searchParams.get("search") || "";

  const debouncedSearch = useDebounce(search, 1000);

  const limit = 10;

  const handlePageChange = (newPage) => {
    setSearchParams({
      page: newPage,
      search,
    });
  };

  const handleSearch = (value) => {
    setSearchParams({
      page: 1,
      search: value,
    });
  };

  // 🔹 Fetch users
  const fetchUsers = async () => {
    try {
      // let res;

      // if (filterType === "active") {
      //   res = await getActiveUsers();
      // } else if (filterType === "inactive") {
      //   res = await getInactiveUsers();
      // } else {
      //   res = await getAllUsers(page, 10, search);
      // }
      setLoading(true);
      const res = await getAllUsers(page, limit, search, filterType);
      console.log("users api resp:", res);
      // setUsers(res.data);
      setUsers(res?.data?.formattedUsers || []);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (err) {
      console.error("Fetch users failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [filterType, page, debouncedSearch]);

  // 🔹 Block user
  const blockUser = async (userId) => {
    try {
      const res = await blockUserApi(userId);
      if (res?.success) {
        toast.success("User Blocked.");
      }
      fetchUsers();
      setActiveMenu(null);
    } catch (err) {
      console.error("Block user failed:", err);
    }
  };

  // 🔹 Unblock user
  const unblockUser = async (userId) => {
    try {
      const res = await unblockUserApi(userId);
      if (res?.success) {
        toast.success("User Unblocked.");
      }
      fetchUsers();
      setActiveMenu(null);
    } catch (err) {
      console.error("Unblock user failed:", err);
    }
  };

  // 🔹 Search filter
  // const filteredUsers = users.filter((u) =>
  //   u.name?.toLowerCase().includes(search.toLowerCase()),
  // );

  return (
    <div>
      <HeaderUser />

      <div className="entire">
        <div className="userlist-card">
          <div className="userlist-title">
            <h3>User List</h3>
            <p>View and manage all users</p>
          </div>

          <div className="userlist-controls">
            <div className="search-boxx">
              <MdSearch />
              <input
                type="text"
                placeholder="Search by username"
                value={search}
                // onChange={(e) => setSearch(e.target.value)}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>

            <div className="filter-wrapper">
              <button onClick={() => setShowFilter(!showFilter)}>
                {filterType
                  ? filterType.charAt(0).toUpperCase() + filterType.slice(1)
                  : "Filter"}{" "}
                <MdFilterList />
              </button>

              {showFilter && (
                <div className="filter-dropdown">
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === "active"}
                      onChange={() => setFilterType("active")}
                      onClick={() => setShowFilter(false)}
                    />
                    Active
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === "inactive"}
                      onChange={() => setFilterType("inactive")}
                      onClick={() => setShowFilter(false)}
                    />
                    Inactive
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === null}
                      onChange={() => setFilterType(null)}
                      onClick={() => setShowFilter(false)}
                    />
                    All
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className="table-contain">
            <table>
              <thead>
                <tr>
                  {columns.map((col, index) => (
                    <th key={index}>{col}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      Loading data...
                    </td>
                  </tr>
                ) : !loading && users.length === 0 ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      User not found.
                    </td>
                  </tr>
                ) : (
                  users?.map((user, index) => (
                    <tr key={user._id}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td>{user.name}</td>
                      <td>{user.userType}</td>
                      <td>{user?.guestId || user?.email}</td>
                      <td>{user?.phoneNo ?? "_"}</td>
                      <td>{user.coins ?? 0}</td>
                      <td>{new Date(user.createdAt).toLocaleString()}</td>
                      <td style={{ color: user.isBlocked ? "red" : "green" }}>
                        {user.isBlocked ? "Blocked" : "Active"}
                      </td>

                      <td className="action-cell">
                        <MdMoreHoriz
                          onClick={() =>
                            setActiveMenu(activeMenu === index ? null : index)
                          }
                        />

                        {activeMenu === index && (
                          <div className="action-menu">
                            <span onClick={() => blockUser(user._id)}>
                              Block
                            </span>
                            <span onClick={() => unblockUser(user._id)}>
                              Unblock
                            </span>

                            <NavLink to={`/Layout/Viewuser/${user._id}`}>
                              <span>View user</span>
                            </NavLink>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
              className="mt-2"
            >
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                // onPageChange={(p) => setPage(p)}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
